import { isChertoCustomerBkExperiment } from 'constants/experiments'
import { CHERTO_USER_ID_UNIT_TYPE } from 'lib/experiments/chertoConstants'

/**
 * Customer BK id for an experiment registered on that unit.
 *
 * Domain User ID experiments keep the existing seed id, so this returns
 * undefined for them.
 */
export function getChertoBucketingId(
  units: Readonly<Record<string, string>> | undefined,
  experimentId: string | undefined,
): string | undefined {
  if (!experimentId || !isChertoCustomerBkExperiment(experimentId)) {
    return
  }

  const unitId = units?.[CHERTO_USER_ID_UNIT_TYPE]
  return unitId || undefined
}
